<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="text-uppercase">
          <h5>Create Special Edition</h5>
        </v-card-title>
        <v-card-text>
          <v-form
            class="mt-3"
            v-model="valid"
            ref="specialEditionForm"
            @submit.prevent="createSpecialEdition"
          >
            <v-text-field
              outlined
              label="Title of edition *"
              v-model="title"
            ></v-text-field>

            <v-text-field
              outlined
              label="Description (optional)"
              v-model="description"
              hide-details
            ></v-text-field>

            <v-divider class="mb-7"></v-divider>

            <p class="mb-7">* mark required fields.</p>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDialog"> Cancel </v-btn>
              <v-btn
                text
                type="submit"
                color="green lighten-1"
                @click="createSpecialEdition"
                :disabled="!valid"
                :loading="creating"
              >
                Save edition
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from "../../../../tools/rules";

export default {
  props: {
    open: { type: Boolean, default: false },
  },

  data: () => ({
    dialog: false,

    title: null,
    description: null,

    creating: false,

    valid: false,
    rules: {
      required,
    },
  }),

  watch: {
    open: {
      handler(value) {
        this.dialog = value;
      },
    },
  },

  methods: {
    closeDialog() {
      this.$emit("cancel");
      this.dialog = false;
    },
    createSpecialEdition() {
      if (!this.creating) {
        this.creating = true;

        const data = {
          title: this.title,
          description: this.description,
        };

        this.$axios
          .post("/special-editions", data)
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Special edition has been created",
            });
            this.dialog = false;
            this.$forceUpdate();
            this.$refs.specialEditionForm.reset();
            this.$emit("refresh");
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not create special edition",
            });
          })
          .finally(() => {
            this.creating = false;
          });
      }
    },
  },
};
</script>